/**
 * ProtectedRoute (CHAP-284) - gates routes behind authentication.
 * Unauthenticated (/api/me 401) → redirect to /login?returnTo=…; loading → spinner.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserRoles } from '../hooks/useUserRoles.js';

export function ProtectedRoute() {
  const { isLoading, user } = useUserRoles();
  const loc = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral text-sm">
        <span className="animate-pulse">Loading…</span>
      </div>
    );
  }

  if (!user) {
    const returnTo = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <Outlet />;
}
